import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, MaskLines } from "./Reveal";
import { useLang, IMG } from "../lib/i18n";

export const About = () => {
  const { t } = useLang();
  const a = t.about;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], ["5%", "-5%"]);
  const y2 = useTransform(scrollYProgress, [0, 1], ["-3%", "8%"]);

  return (
    <section id="about" ref={ref} data-testid="about-section" className="relative bg-[#F6F2EC] py-24 sm:py-36">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10 grid lg:grid-cols-12 gap-14 lg:gap-10">
        <div className="lg:col-span-5 relative order-2 lg:order-1">
          <div className="relative h-[520px] sm:h-[620px]">
            <motion.div style={{ y: y1 }} className="absolute left-0 top-0 w-[78%] sm:w-[72%] h-[76%] overflow-hidden rounded-t-[200px]">
              <img src={IMG.cabina} alt="Gioia Anfosso in cabina" className="w-full h-full object-cover object-[80%_25%] sm:object-[68%_25%]" />
            </motion.div>
            <motion.div style={{ y: y2 }} className="absolute right-0 bottom-0 w-[50%] h-[48%] overflow-hidden border-[10px] border-[#F6F2EC] shadow-[0_30px_80px_-30px_rgba(20,17,15,0.45)]">
              <img src={IMG.team} alt="Il team di Gioia Centro Estetico" className="w-full h-full object-cover object-[50%_35%]" />
            </motion.div>
          </div>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 order-1 lg:order-2 flex flex-col justify-center">
          <Reveal><p className="overline text-[#8A6A3A] mb-8">{a.over}</p></Reveal>
          <h2 data-testid="about-title" className="font-serif-d font-light text-[2.6rem] sm:text-6xl leading-[1] tracking-[-0.01em] text-[#14110F]">
            <MaskLines key={a.title.join()} inView lines={[a.title[0], a.title[1]]} />
            <MaskLines key={a.title[2]} inView delay={0.25} lines={[a.title[2]]} lineClass="italic text-[#8A6A3A]" />
          </h2>
          <Reveal delay={0.1} className="mt-10 grid sm:grid-cols-2 gap-6 text-[#4f4841] leading-relaxed font-light">
            <p>{a.p1}</p>
            <p>{a.p2}</p>
          </Reveal>
          <Reveal delay={0.2} className="mt-14 grid grid-cols-3 border-t border-[#ddd4c7]">
            {a.stats.map(([n, l], i) => (
              <div key={l} data-testid={`about-stat-${i}`} className={`pt-6 ${i ? "pl-4 sm:pl-8 border-l border-[#ddd4c7]" : ""}`}>
                <div className="font-serif-d text-4xl sm:text-5xl text-[#14110F]">{n}</div>
                <div className="text-xs sm:text-sm text-[#5a534c] mt-2">{l}</div>
              </div>
            ))}
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-10 font-serif-d italic text-2xl text-[#14110F]" data-testid="about-signature">{a.sign}</p>
            <p className="overline text-[#5a534c] mt-2 text-[0.62rem]">{a.role}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
